
module.exports = { 
      attributes: {},
    
      body: "A facility/service dedicated to the treatment of alcohol and drug dependence.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/alcohol-tobacco-and-other-drugs.md"},
     }